import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { Metric } from "../../metric";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var BEELINE_LOGO = '//static.beeline.ru/upload/images/b2c/bee-logo/single.png';
export var Logo = function Logo(_ref) {
  var className = _ref.className,
    imgClassName = _ref.imgClassName,
    title = _ref.title,
    src = _ref.src,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '/customers/products/' : _ref$href,
    env = _ref.env;
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: "logo",
    events: {
      headerMetric: ['handleTopIconClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement("a", {
    className: cn('wrapper', className, {
      'wrapper--disabled': !href
    }),
    href: href
  }, /*#__PURE__*/React.createElement("img", {
    alt: "\u0431\u0438\u043B\u0430\u0439\u043D",
    className: cn('logo-img', imgClassName),
    src: src || BEELINE_LOGO
  }), title && /*#__PURE__*/React.createElement("h3", {
    className: cn('title')
  }, title), env && /*#__PURE__*/React.createElement(Text, {
    className: cn('env'),
    size: 12
  }, env)));
};